import React from "react";
import UploadVAReportMenu from "../components/menu/admin/UploadVAReportMenu";

const UploadVAReport = () => {
  return <UploadVAReportMenu />;
};

export default UploadVAReport;
